"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.544 17.5c.984-.409 9.956-4.316 9.956-10.873 0-6.938-5.876-6.095-5.876-6.095S11.764.847 10.5 3.24C9.235.847 6.376.532 6.376.532S.5-.31.5 6.627c0 6.557 8.972 10.464 9.956 10.873h.088z",
    clipRule: "evenodd"
  }));
}

var MemoSvgHeart = /*#__PURE__*/React.memo(SvgHeart);
var _default = MemoSvgHeart;
exports["default"] = _default;